module.exports = __webpack_public_path__ + "assets/img/driver-btn-59a593f2.png";